import React, { useEffect, useState } from 'react';

const CursorTrail = () => {
  const [trails, setTrails] = useState([]);
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const newTrail = {
        x: e.clientX,
        y: e.clientY,
        id: Date.now(),
      };

      setTrails((prev) => [newTrail, ...prev.slice(0, 5)]);
    };

    const handleMouseOver = () => setIsHovering(true);
    const handleMouseOut = () => setIsHovering(false);

    window.addEventListener('mousemove', handleMouseMove);

    // Add listeners for interactive elements
    const interactiveElements = document.querySelectorAll('a, button');
    interactiveElements.forEach(el => {
      el.addEventListener('mouseover', handleMouseOver);
      el.addEventListener('mouseout', handleMouseOut);
    });

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      interactiveElements.forEach(el => {
        el.removeEventListener('mouseover', handleMouseOver);
        el.removeEventListener('mouseout', handleMouseOut);
      });
    };
  }, []);

  return (
    <div className="pointer-events-none fixed inset-0 z-50">
      {trails.map((trail, index) => (
        <div
          key={trail.id}
          className="absolute pointer-events-none"
          style={{
            left: trail.x,
            top: trail.y,
            width: `${4 - index * 0.3}px`,
            height: `${4 - index * 0.3}px`,
            background: `radial-gradient(circle, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0) 80%)`,
            opacity: 1 - index * 0.1,
            transform: `translate(-50%, -50%) scale(${1 - index * 0.1})`,
            transition: 'all 0.3s ease-out',
            borderRadius: '50%',
            filter: isHovering ? 'brightness(1.5)' : 'none'
          }}
        />
      ))}
    </div>
  );
};

export default CursorTrail;